const analyticFeedback = (Analytic) => {
    Analytic.prototype.feedbackSelect = function (page, feedback_text, feedback_response) {
        this.track('Feedback Select', {
            page,
            feedback_text,
            feedback_response
        })
    }

    Analytic.prototype.feedbackSubmit = function (page, feedback_text, feedback_response) {
        this.track('Feedback Submit', {
            page,
            feedback_text,
            feedback_response
        })
    }
}

export default analyticFeedback
